import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ribbon--sprite",
  "use": "ribbon--sprite-usage",
  "viewBox": "0 0 186.6 286.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 186.6 286.2\" id=\"ribbon--sprite\"><path class=\"cls-1\" d=\"M112 243.2l42.2 42.3 18.7-19 -42-42M140.2 140.1h-0.1L93.3 187l-46.8-46.9h-0.1c-25.9-25.9-25.8-67.9 0.1-93.7 25.9-25.9 67.9-25.8 93.7 0.1C166 72.3 166 114.2 140.2 140.1M158.3 159.6c36.6-35.9 37.2-94.6 1.3-131.2C123.7-8.3 64.9-8.8 28.3 27 -8.3 62.9-8.8 121.7 27 158.3c0.4 0.4 0.9 0.9 1.3 1.3l0 0L74.6 206l-60.8 60.6 18.7 19L158.3 159.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol